import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { MapPlace } from '../models/MapPlace';
import { MapV2Service } from '../mapv2.service';
import { Subject } from 'rxjs';
import { MapView } from '../models/Map';
import { PlaceTicket } from '../models/PlaceTicket';

@Component({
  selector: 'mapv2-tickets',
  templateUrl: './mapv2-tickets.component.html',
  styleUrls: ['./mapv2-tickets.component.scss']
})
export class MapV2TicketsComponent implements OnDestroy, OnChanges {
  public ticketId: string;
  private unsubscribe$: Subject<void>;

  @Input()
  public place!: MapPlace;

  constructor(
    private service: MapV2Service
  ) {
    this.unsubscribe$ = new Subject();
    this.ticketId = '';
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public ngOnChanges(): void {
    if (this.place && this.place.selectedTicket) {
      this.ticketId = this.place.selectedTicket.id;
    }
  }

  public selectTicket(): void {
    const ticket = this.place.tickets.find(t => t.id === this.ticketId) as PlaceTicket;
    this.service.reserve(this.place, ticket)
      .then(() => {
        this.service.setView(MapView.PLACES);
      });
  }

  public unselectTicket(): void {
    this.service.cancelReserve(this.place)
      .then(() => {
        this.ticketId = '';
        this.service.setView(MapView.PLACES);
      });
  }

  public amount(value: number): number {
    return value * this.place.quantity;
  }
}
